export default __webpack_public_path__ + "static/media/confirmed_white.5ff81c91.svg";